import { render, staticRenderFns } from "./ARPU.vue?vue&type=template&id=00960336&scoped=true"
import script from "./ARPU.vue?vue&type=script&lang=js"
export * from "./ARPU.vue?vue&type=script&lang=js"
import style0 from "./ARPU.vue?vue&type=style&index=0&id=00960336&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00960336",
  null
  
)

export default component.exports